import moment from 'moment';
import { GROWTH_SCHEDULER_REPORT_BUTTON_CLICKED } from '../../GrowthSegmentEvents';
export class ScheduleItemController {
    static $inject = ['SchedulerService', 'GrowthSegmentService', 'BlipToastService', '$translate'];
    constructor(SchedulerService, GrowthSegmentService, BlipToastService, $translate) {
        'ngInject';
        this.SchedulerService = SchedulerService;
        this.GrowthSegmentService = GrowthSegmentService;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.isDownloadingReport = new Map();
    }
    get formatedDate() {
        return moment(this.schedule.when).format('L - HH:mm');
    }
    $deleteModel(event) {
        event.stopPropagation();
        event.preventDefault();
        this.onDelete({ $item: this.schedule });
    }
    showDownloadButton() {
        const isEmpty = Object.keys(this.schedule.distributionListMessage).length === 0;
        return this.canShowDownloadButton && !isEmpty;
    }
    async downloadScheduleItem(scheduleItem) {
        if (this.isDownloadingReport[scheduleItem.id] === true) {
            return;
        }
        this.isDownloadingReport[scheduleItem.id] = true;
        const scheduleItemName = scheduleItem.name;
        this.SchedulerService.downloadSchedulerReport(scheduleItem.message.to, scheduleItem.message.id, scheduleItem.name, async (err) => {
            this.isDownloadingReport[scheduleItem.id] = false;
            this.GrowthSegmentService.trackEvent(GROWTH_SCHEDULER_REPORT_BUTTON_CLICKED, { status: err === undefined });
            this.BlipToastService.show('success', {
                title: scheduleItemName,
                msg: await this.$translate.instant('schedule.toast.success'),
            });
        });
    }
}
ScheduleItemController.$inject = ['SchedulerService', 'GrowthSegmentService', 'BlipToastService', '$translate'];
